import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtistPartnerProfile = (params, page = 1, pageSize = 2147483647) => {
  return axios.get(URL_PREFIX + '/artist-partner-profiles/?page=' + page + '&page_size=' + pageSize, {
    params
  })
}

export const getArtistPartnerProfile = (id) => {
  return axios.get(URL_PREFIX + '/artist-partner-profiles/' + id + '/')
}

export const postPartnerProfile = (params) => {
  return axios.post(URL_PREFIX + '/artist-partner-profiles/', params)
}

export const patchPartnerProfile = (id, params) => {
  return axios.patch(URL_PREFIX + '/artist-partner-profiles/' + id + '/', params)
}

export const deleteArtistPartnerProfile = (id) => {
  return axios.delete(URL_PREFIX + '/artist-partner-profiles/' + id + '/')
}
/*
export const getAllArtistContact = (params, page = 1, pageSize = 2147483647) => {
  return axios.get(URL_PREFIX + '/artist-contacts/?page=' + page + '&page_size=' + pageSize, {
    params
  })
}*/

export const getAllArtistContact = (params, cancelToken) => {
  return axios.get(URL_PREFIX + '/artist-contacts/', {
    params: params,
    cancelToken: cancelToken?.token
  })
}

export const getArtistContact = (id) => {
  return axios.get(URL_PREFIX + '/artist-contacts/' + id + '/')
}

export const postArtistContact = (params) => {
  return axios.post(URL_PREFIX + '/artist-contacts/', params)
}

export const patchArtistContact = (id, params) => {
  return axios.patch(URL_PREFIX + '/artist-contacts/' + id + '/', params)
}

export const deleteArtistContact = (id) => {
  return axios.delete(URL_PREFIX + '/artist-contacts/' + id + '/')
}

export const bulkPatchArtistContact = (data, cancelToken) => {
    return axios.patch('/bulk/artist-contacts', data, {
        cancelToken: cancelToken?.token
    })
}

export const bulkAddArtistContact = (data, cancelToken) => {
  return axios.post('/bulk/artist-contacts', data, {
      cancelToken: cancelToken?.token
})
}